import { Box, Typography } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { memo } from 'react';

import { badgeSx, badgeTextSx, imageContainerSx, imageSx, timeToReadSx, titleSx } from './styles';

type TArticleCardSmProps = {
  image: string;
  title: string;
  isNew?: boolean;
  timeToRead?: number;
  imageHeight?: number;
  articleId?: string | number;
  source?: string;
  onClick?: () => void;
};

export const ArticleCardSm = memo(
  ({ image, title, isNew, timeToRead, imageHeight, articleId, source, onClick }: TArticleCardSmProps) => {
    return (
      <Box sx={{ position: 'relative', cursor: articleId ? 'pointer' : 'default' }}>
        {articleId && (
          // @ts-expect-error strictNullChecks breaks TanStack Router inference
          <Box
            component={Link}
            to="/article"
            search={{ id: Number(articleId), source }}
            onClick={onClick}
            sx={{ position: 'absolute', inset: 0, zIndex: 1 }}
          />
        )}
        <Box sx={imageContainerSx(imageHeight)}>
          <Box component="img" src={image} alt={title} loading="lazy" sx={imageSx} />
          {isNew && (
            <Box sx={badgeSx}>
              <Typography sx={badgeTextSx}>New</Typography>
            </Box>
          )}
        </Box>
        <Typography sx={titleSx}>{title}</Typography>
        {timeToRead && <Typography sx={timeToReadSx}>{timeToRead} min read</Typography>}
      </Box>
    );
  },
);
